'use client'

import { z } from 'zod'

const schema = z.object({
  data: z.object({
    withCutLines: z.boolean().optional(),
  }),
})

type ProductStickersSessionStorage = z.infer<typeof schema>

const defaultValue: ProductStickersSessionStorage = { data: {} }

export function getProductStickersSessionStorage(): ProductStickersSessionStorage {
  try {
    const storedValue = JSON.parse(
      window.sessionStorage.getItem('productStickers') || '{ "data": {} }',
    )

    return schema.parse(storedValue) ?? defaultValue
  } catch {
    console.error('Failed to read productStickers from sessionStorage')

    return defaultValue
  }
}
